webpackJsonp([35783957827783],{

/***/ 40:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	module.exports = murmurhash2_32_gc;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(19));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan)|(on[A-Z].*)|((data|aria)-.*))$/;
	var index = memoize(RegExp.prototype.test.bind(reactPropsRegex));
	
	module.exports = index;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	'use strict';
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	module.exports = memoize;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	'use strict';
	
	var V = function ca(W) {
	  function M(e, c, d, h, a) {
	    for (var l = 0, b = 0, u = 0, k = 0, q, m, f, D = 0, y = 0, r, E = r = q = 0, n = 0, J = m = 0, t = 0, K = d.length, F = K - 1, w, g = "", p = "", G = "", H = "", A; n < K;) {
	      f = d.charCodeAt(n);
	      n === F && 0 !== b + k + u + l && (0 !== b && (f = 47 === b ? 10 : 47), k = u = l = 0, K++, F++);
	
	      if (0 === b + k + u + l) {
	        if (n === F && (0 < m && (g = g.replace(N, "")), 0 < g.trim().length)) {
	          switch (f) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              g += d.charAt(n);
	          }
	
	          f = 59;
	        }
	
	        switch (f) {
	          case 123:
	            g = g.trim();
	            q = g.charCodeAt(0);
	            r = 1;
	
	            for (t = ++n; n < K;) {
	              f = d.charCodeAt(n);
	
	              switch (f) {
	                case 123:
	                  r++;
	                  break;
	
	                case 125:
	                  r--;
	              }
	
	              if (0 === r) break;
	              n++;
	            }
	
	            f = d.substring(t, n);
	            0 === q && (q = (g = g.replace(da, "").trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < m && (g = g.replace(N, ""));
	                m = g.charCodeAt(1);
	
	                switch (m) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                f = M(c, r, f, m, a + 1);
	                t = f.length;
	                0 < z && (r = X(O, g, J), A = I(3, f, r, c, B, x, t, m, a, h), g = r.join(""), void 0 !== A && 0 === (t = (f = A.trim()).length) && (m = 0, f = ""));
	                if (0 < t) switch (m) {
	                  case 115:
	                    g = g.replace(ea, fa);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    f = g + "{" + f + "}";
	                    break;
	
	                  case 107:
	                    g = g.replace(ha, "$1 $2");
	                    f = g + "{" + f + "}";
	                    f = 1 === v || 2 === v && L("@" + f, 3) ? "@-webkit-" + f + "@" + f : "@" + f;
	                    break;
	
	                  default:
	                    f = g + f, 112 === h && (f = (p += f, ""));
	                } else f = "";
	                break;
	
	              default:
	                f = M(c, X(c, g, J), f, h, a + 1);
	            }
	
	            G += f;
	            r = J = m = E = q = 0;
	            g = "";
	            f = d.charCodeAt(++n);
	            break;
	
	          case 125:
	          case 59:
	            g = (0 < m ? g.replace(N, "") : g).trim();
	            if (1 < (t = g.length)) switch (0 === E && (q = g.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (g = g.replace(" ", ":")).length), 0 < z && void 0 !== (A = I(1, g, c, e, B, x, p.length, h, a, h)) && 0 === (t = (g = A.trim()).length) && (g = "\x00\x00"), q = g.charCodeAt(0), m = g.charCodeAt(1), q + m) {
	              case 0:
	                break;
	
	              case 169:
	              case 163:
	                H += g + d.charAt(n);
	                break;
	
	              default:
	                58 !== g.charCodeAt(t - 1) && (p += P(g, q, m, g.charCodeAt(2)));
	            }
	            J = m = E = q = 0;
	            g = "";
	            f = d.charCodeAt(++n);
	        }
	      }
	
	      switch (f) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && (m = 1, g += "\x00");
	          0 < z * Y && I(0, g, c, e, B, x, p.length, h, a, h);
	          x = 1;
	          B++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + k + u + l) {
	            x++;
	            break;
	          }
	
	        default:
	          x++;
	          w = d.charAt(n);
	
	          switch (f) {
	            case 9:
	            case 32:
	              if (0 === k + l + b) switch (D) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  w = "";
	                  break;
	
	                default:
	                  32 !== f && (w = " ");
	              }
	              break;
	
	            case 0:
	              w = "\\0";
	              break;
	
	            case 12:
	              w = "\\f";
	              break;
	
	            case 11:
	              w = "\\v";
	              break;
	
	            case 38:
	              0 === k + b + l && (m = J = 1, w = "\f" + w);
	              break;
	
	            case 108:
	              if (0 === k + b + l + C && 0 < E) switch (n - E) {
	                case 2:
	                  112 === D && 58 === d.charCodeAt(n - 3) && (C = D);
	
	                case 8:
	                  111 === y && (C = y);
	              }
	              break;
	
	            case 58:
	              0 === k + b + l && (E = n);
	              break;
	
	            case 44:
	              0 === b + u + k + l && (m = 1, w += "\r");
	              break;
	
	            case 34:
	              0 === b && (k = k === f ? 0 : 0 === k ? f : k);
	              break;
	
	            case 39:
	              0 === b && (k = k === f ? 0 : 0 === k ? f : k);
	              break;
	
	            case 91:
	              0 === k + b + u && l++;
	              break;
	
	            case 93:
	              0 === k + b + u && l--;
	              break;
	
	            case 41:
	              0 === k + b + l && u--;
	              break;
	
	            case 40:
	              if (0 === k + b + l) {
	                if (0 === q) switch (2 * D + 3 * y) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                u++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + u + k + l + E + r && (r = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < k + l + u)) switch (b) {
	                case 0:
	                  switch (2 * f + 3 * d.charCodeAt(n + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = n, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === f && 42 === D && (33 === d.charCodeAt(t + 2) && (p += d.substring(t, n + 1)), w = "", b = 0);
	              }
	          }
	
	          0 === b && (g += w);
	      }
	
	      y = D;
	      D = f;
	      n++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < z && (A = I(2, p, r, e, B, x, t, h, a, h), void 0 !== A && 0 === (p = A).length)) return H + p + G;
	      p = r.join(",") + "{" + p + "}";
	
	      if (0 !== v * C) {
	        2 !== v || L(p, 2) || (C = 0);
	
	        switch (C) {
	          case 111:
	            p = p.replace(ia, ":-moz-$1") + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
	        }
	
	        C = 0;
	      }
	    }
	
	    return H + p + G;
	  }
	
	  function X(e, c, d) {
	    var h = c.trim().split(ja);
	    c = h;
	    var a = h.length,
	        l = e.length;
	
	    switch (l) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (e = 0 === l ? "" : e[0] + " "; b < a; ++b) {
	          c[b] = Z(e, c[b], d, l).trim();
	        }
	
	        break;
	
	      default:
	        var u = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var k = 0; k < l; ++k) {
	            c[u++] = Z(e[k] + " ", h[b], d, l).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(e, c, d) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, "$1" + e.trim());
	
	      case 58:
	        switch (c.charCodeAt(1)) {
	          case 103:
	            break;
	
	          default:
	            return e.trim() + c.replace(F, "$1" + e.trim());
	        }
	
	      default:
	        if (0 < 1 * d && 0 < c.indexOf("\f")) return c.replace(F, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
	    }
	
	    return e + c;
	  }
	
	  function P(e, c, d, h) {
	    var a = e + ";",
	        l = 2 * c + 3 * d + 4 * h;
	
	    if (944 === l) {
	      e = a.indexOf(":", 9) + 1;
	      var b = a.substring(e, a.length - 1).trim();
	      b = a.substring(0, e).trim() + b + ";";
	      return 1 === v || 2 === v && L(b, 1) ? "-webkit-" + b + b : b;
	    }
	
	    if (0 === v || 2 === v && !L(a, 1)) return a;
	
	    switch (l) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return "-webkit-" + a + a;
	
	      case 978:
	        return "-webkit-" + a + "-moz-" + a + a;
	
	      case 1019:
	      case 983:
	        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
	
	      case 883:
	        return 45 === a.charCodeAt(8) ? "-webkit-" + a + a : a;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
	
	          case 115:
	            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
	
	          case 98:
	            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
	        }
	        return "-webkit-" + a + "-ms-" + a + a;
	
	      case 964:
	        return "-webkit-" + a + "-ms-flex-" + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
	        return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf("-") + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, "tb");
	            break;
	
	          case 232:
	            b = a.replace(G, "tb-rl");
	            break;
	
	          case 220:
	            b = a.replace(G, "lr");
	            break;
	
	          default:
	            return a;
	        }
	
	        return "-webkit-" + a + "-ms-" + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf("sticky", 9)) break;
	
	      case 975:
	        c = (a = e).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(e.indexOf(":", 7) + 1).trim();
	
	        switch (l = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, "-webkit-" + b) + ";" + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, "-webkit-" + (102 < l ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
	        }
	
	        return a + ";";
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
	
	          case 115:
	            return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
	
	          default:
	            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(e)) return 115 === (b = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? P(e.replace("stretch", "fill-available"), c, d, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
	        break;
	
	      case 962:
	        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === d + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
	    }
	
	    return a;
	  }
	
	  function L(e, c) {
	    var d = e.indexOf(1 === c ? ":" : "{"),
	        h = e.substring(0, 3 !== c ? d : 10);
	    d = e.substring(d + 1, e.length - 1);
	    return H(2 !== c ? h : h.replace(na, "$1"), d, c);
	  }
	
	  function fa(e, c) {
	    var d = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return d !== c + ";" ? d.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
	  }
	
	  function I(e, c, d, h, a, l, b, u, k, q) {
	    for (var m = 0, f = c, v; m < z; ++m) {
	      switch (v = R[m].call(y, e, f, d, h, a, l, b, u, k, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          f = v;
	      }
	    }
	
	    switch (f) {
	      case void 0:
	      case !1:
	      case !0:
	      case null:
	      case c:
	        break;
	
	      default:
	        return f;
	    }
	  }
	
	  function S(e) {
	    switch (e) {
	      case void 0:
	      case null:
	        z = R.length = 0;
	        break;
	
	      default:
	        switch (e.constructor) {
	          case Array:
	            for (var c = 0, d = e.length; c < d; ++c) {
	              S(e[c]);
	            }
	
	            break;
	
	          case Function:
	            R[z++] = e;
	            break;
	
	          case Boolean:
	            Y = !!e | 0;
	        }
	
	    }
	
	    return S;
	  }
	
	  function T(e) {
	    for (var c in e) {
	      var d = e[c];
	
	      switch (c) {
	        case "prefix":
	          H = null, d ? "function" !== typeof d ? v = 1 : (v = 2, H = d) : v = 0;
	      }
	    }
	
	    return T;
	  }
	
	  function y(e, c) {
	    if (void 0 !== this && this.constructor === y) return ca(e);
	    var d = e;
	    33 > d.charCodeAt(0) && (d = d.trim());
	    U = d;
	    d = [U];
	
	    if (0 < z) {
	      var h = I(-1, c, d, d, B, x, 0, 0, 0, 0);
	      void 0 !== h && "string" === typeof h && (c = h);
	    }
	
	    var a = M(O, d, c, 0, 0);
	    0 < z && (h = I(-2, a, d, d, B, x, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    U = "";
	    C = 0;
	    x = B = 1;
	    return a;
	  }
	
	  var da = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ja = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      ha = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ia = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      ea = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      x = 1,
	      B = 1,
	      C = 0,
	      v = 1,
	      O = [],
	      R = [],
	      z = 0,
	      H = null,
	      Y = 0,
	      U = "";
	  y.use = S;
	  y.set = T;
	  void 0 !== W && T(W);
	  return y;
	};
	
	module.exports = V;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	'use strict';
	
	var index = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	module.exports = index;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var PropTypes = _interopDefault(__webpack_require__(7));
	var isPropValid = _interopDefault(__webpack_require__(76));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var channel = '__EMOTION_THEMING__';
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	
	var _contextTypes;
	
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	var testPickPropsOnStringTag = isPropValid;
	var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	var pickAssign = function pickAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	
	    var _key = void 0;
	
	    for (_key in source) {
	      if (testFn(_key)) {
	        target[_key] = source[_key];
	      }
	    }
	  }
	
	  return target;
	};
	
	function _componentWillMount() {
	  if (this.context[channel] !== undefined) {
	    this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	  }
	}
	
	function _componentWillUnmount() {
	  if (this.unsubscribe !== undefined) {
	    this.context[channel].unsubscribe(this.unsubscribe);
	  }
	}
	
	function _get(target, property) {
	  switch (property) {
	    // react-hot-loader tries to access this stuff
	    case '__proto__':
	    case 'name':
	    case 'prototype':
	    case 'displayName':
	      {
	        return target[property];
	      }
	
	    default:
	      {
	        throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
	      }
	  }
	}
	
	function createEmotionStyled(emotion, view) {
	  var _createStyled = function createStyled(tag, options) {
	    if (false) {
	      if (tag === undefined) {
	        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	      }
	    }
	
	    var staticClassName;
	    var identifierName;
	    var stableClassName;
	    var shouldForwardProp;
	
	    if (options !== undefined) {
	      staticClassName = options.e;
	      identifierName = options.label;
	      stableClassName = options.target;
	      shouldForwardProp = options.shouldForwardProp;
	    }
	
	    var isReal = tag.__emotion_real === tag;
	    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	
	    if (typeof shouldForwardProp !== 'function') {
	      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
	    }
	
	    function _value() {
	      if (false) {
	        return 'NO_COMPONENT_SELECTOR';
	      } // $FlowFixMe
	
	
	      return "." + stableClassName;
	    }
	
	    return function () {
	      var args = arguments;
	      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
	
	      if (identifierName !== undefined) {
	        styles.push("label:" + identifierName + ";");
	      }
	
	      if (staticClassName === undefined) {
	        if (args[0] == null || args[0].raw === undefined) {
	          styles.push.apply(styles, args);
	        } else {
	          styles.push(args[0][0]);
	          var len = args.length;
	          var i = 1;
	
	          for (; i < len; i++) {
	            styles.push(args[i], args[0][i]);
	          }
	        }
	      }
	
	      function _render() {
	        var props = this.props,
	            state = this.state;
	        this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
	          theme: state !== null && state.theme || props.theme || {}
	        });
	        var className = '';
	        var classInterpolations = [];
	
	        if (props.className) {
	          if (staticClassName === undefined) {
	            className += emotion.getRegisteredStyles(classInterpolations, props.className);
	          } else {
	            className += props.className + " ";
	          }
	        }
	
	        if (staticClassName === undefined) {
	          className += emotion.css.apply(this, styles.concat(classInterpolations));
	        } else {
	          className += staticClassName;
	        }
	
	        if (stableClassName !== undefined) {
	          className += " " + stableClassName;
	        }
	
	        return view.createElement(baseTag, // $FlowFixMe
	        pickAssign(shouldForwardProp, {}, props, {
	          className: className,
	          ref: props.innerRef
	        }));
	      }
	
	      var Styled =
	      /*#__PURE__*/
	      function (_view$Component) {
	        _inheritsLoose(Styled, _view$Component);
	
	        function Styled() {
	          return _view$Component.apply(this, arguments) || this;
	        }
	
	        var _proto = Styled.prototype;
	        _proto.componentWillMount = _componentWillMount;
	        _proto.componentWillUnmount = _componentWillUnmount;
	        _proto.render = _render;
	        return Styled;
	      }(view.Component);
	
	      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	      Styled.contextTypes = contextTypes;
	      Styled.__emotion_styles = styles;
	      Styled.__emotion_base = baseTag;
	      Styled.__emotion_real = Styled;
	      Object.defineProperty(Styled, 'toString', {
	        enumerable: false,
	        value: _value
	      });
	
	      Styled.withComponent = function (nextTag, nextOptions) {
	        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
	        pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
	      };
	
	      return Styled;
	    };
	  };
	
	  if (false) {
	    _createStyled = new Proxy(_createStyled, {
	      get: _get
	    });
	  }
	
	  return _createStyled;
	}
	
	module.exports = createEmotionStyled;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(40));
	var Stylis = _interopDefault(__webpack_require__(41));
	var stylisRuleSheet = _interopDefault(__webpack_require__(56));
	var memoize = _interopDefault(__webpack_require__(19));
	var unitless = _interopDefault(__webpack_require__(42));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    return oldProcessStyleValue(key, value);
	  };
	}
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	function _StyleSheet(options) {
	  this.isSpeedy = ("production") === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	  this.tags = [];
	  this.ctr = 0;
	  this.opts = options;
	}
	
	function _inject() {
	  if (this.injected) {
	    throw new Error('already injected!');
	  }
	
	  this.tags[0] = makeStyleTag(this.opts);
	  this.injected = true;
	}
	
	function _speedy(bool) {
	  if (this.ctr !== 0) {
	    // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	    throw new Error("cannot change speedy now");
	  }
	
	  this.isSpeedy = !!bool;
	}
	
	function _insert(rule, sourceMap) {
	  // this is the ultrafast version, works across browsers
	  if (this.isSpeedy) {
	    var tag = this.tags[this.tags.length - 1];
	    var sheet = sheetForTag(tag);
	
	    try {
	      sheet.insertRule(rule, sheet.cssRules.length);
	    } catch (e) {
	      if (false) {
	        console.warn('illegal rule', rule); // eslint-disable-line no-console
	      }
	    }
	  } else {
	    var _tag = makeStyleTag(this.opts);
	
	    this.tags.push(_tag);
	
	    _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	  }
	
	  this.ctr++;
	
	  if (this.ctr % 65000 === 0) {
	    this.tags.push(makeStyleTag(this.opts));
	  }
	}
	
	function _ref(tag) {
	  return tag.parentNode.removeChild(tag);
	}
	
	function _flush() {
	  // $FlowFixMe
	  this.tags.forEach(_ref);
	  this.tags = [];
	  this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	  this.injected = false;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  var _proto = _StyleSheet.prototype;
	  _proto.inject = _inject;
	  _proto.speedy = _speedy;
	  _proto.insert = _insert;
	  _proto.flush = _flush;
	  return _StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (context.__SECRET_EMOTION__ !== undefined) {
	    return context.__SECRET_EMOTION__;
	  }
	
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (false) {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = stylisRuleSheet(insertRule);
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var caches = {
	    registered: {},
	    inserted: {},
	    nonce: options.nonce,
	    key: key
	  };
	  var sheet = new StyleSheet(options);
	
	  if (isBrowser) {
	    // 🚀
	    sheet.inject();
	  }
	
	  var stylis = new Stylis(stylisOptions);
	  stylis.use(options.stylisPlugins)(insertionPlugin);
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation.__emotion_styles !== undefined) {
	          var selector = interpolation.toString();
	
	          if (selector === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          return selector;
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    function _ref(interpolation) {
	      string += handleInterpolation.call(this, interpolation, false);
	    }
	
	    function _ref3(key) {
	      function _ref2(value) {
	        string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
	      }
	
	      if (typeof obj[key] !== 'object') {
	        if (caches.registered[obj[key]] !== undefined) {
	          string += key + "{" + caches.registered[obj[key]] + "}";
	        } else {
	          string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	        }
	      } else {
	        if (key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
	          obj[key].forEach(_ref2);
	        } else {
	          string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	        }
	      }
	    }
	
	    if (Array.isArray(obj)) {
	      obj.forEach(_ref, this);
	    } else {
	      Object.keys(obj).forEach(_ref3, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var stylesWithLabel;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    stylesWithLabel = styles;
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = hashString(styles + identifierName) + identifierName;
	    return styles;
	  };
	
	  if (false) {
	    var sourceMapRegEx = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      var result = sourceMapRegEx.exec(styles);
	      currentSourceMap = result ? result[0] : '';
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = stylesWithLabel;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  function _ref4(node) {
	    // $FlowFixMe
	    sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	    node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	  }
	
	  if (isBrowser) {
	    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(chunks, _ref4);
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  context.__SECRET_EMOTION__ = emotion;
	  return emotion;
	}
	
	module.exports = createEmotion;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(32);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(5);
	var PropTypes = _interopDefault(__webpack_require__(7));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(34));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    for (var key in listeners) {
	      // $FlowFixMe
	      var listener = listeners[key];
	
	      if (listener === undefined) {
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return {
	    publish: publish,
	    subscribe: subscribe,
	    unsubscribe: unsubscribe
	  };
	};
	
	var channel = '__EMOTION_THEMING__';
	
	var _contextTypes;
	
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	// adapted from styled-components' ThemeProvider
	// https://github.com/styled-components/styled-components/blob/4503cab5b86aa9ef8314c5baa360a2fbb4812485/src/models/ThemeProvider.js
	var isPlainObject = function isPlainObject(test) {
	  return Object.prototype.toString.call(test) === '[object Object]';
	};
	
	function _componentWillMount() {
	  var _this2 = this;
	
	  function _ref2(theme) {
	    _this2.outerTheme = theme;
	
	    if (_this2.broadcast !== undefined) {
	      _this2.publish(_this2.props.theme);
	    }
	  }
	
	  // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	  // with the outer theme
	  if (this.context[channel] !== undefined) {
	    this.unsubscribeToOuterId = this.context[channel].subscribe(_ref2);
	  }
	
	  this.broadcast = createBroadcast(this.getTheme(this.props.theme));
	}
	
	function _getChildContext() {
	  var _ref;
	
	  return _ref = {}, _ref[channel] = {
	    subscribe: this.broadcast.subscribe,
	    unsubscribe: this.broadcast.unsubscribe
	  }, _ref;
	}
	
	function _componentWillReceive(nextProps) {
	  if (this.props.theme !== nextProps.theme) {
	    this.publish(nextProps.theme);
	  }
	}
	
	function _componentWillUnmount() {
	  var themeContext = this.context[channel];
	
	  if (themeContext !== undefined) {
	    themeContext.unsubscribe(this.unsubscribeToOuterId);
	  }
	}
	
	function _getTheme(theme) {
	  if (typeof theme === 'function') {
	    var mergedTheme = theme(this.outerTheme);
	
	    if (!isPlainObject(mergedTheme)) {
	      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	    }
	
	    return mergedTheme;
	  }
	
	  if (!isPlainObject(theme)) {
	    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	  }
	
	  if (this.outerTheme === undefined) {
	    return theme;
	  }
	
	  return _extends({}, this.outerTheme, theme);
	}
	
	function _publish(theme) {
	  this.broadcast.publish(this.getTheme(theme));
	}
	
	function _render() {
	  if (!this.props.children) {
	    return null;
	  }
	
	  return React.Children.only(this.props.children);
	}
	
	var ThemeProvider =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    var _this;
	
	    _this = _Component.call(this) || this;
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  var _proto = ThemeProvider.prototype;
	  _proto.componentWillMount = _componentWillMount;
	  _proto.getChildContext = _getChildContext;
	  _proto.componentWillReceiveProps = _componentWillReceive;
	  _proto.componentWillUnmount = _componentWillUnmount; // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	  _proto.getTheme = _getTheme;
	  _proto.publish = _publish;
	  _proto.render = _render;
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextTypes;
	ThemeProvider.contextTypes = contextTypes;
	
	function _componentWillMount$1() {
	  var _this = this;
	
	  var themeContext = this.context[channel];
	
	  if (themeContext === undefined) {
	    // eslint-disable-next-line no-console
	    console.error('[withTheme] Please use ThemeProvider to be able to use withTheme');
	    return;
	  }
	
	  this.unsubscribeId = themeContext.subscribe(function (theme) {
	    _this.setState({
	      theme: theme
	    });
	  });
	}
	
	function _componentWillUnmount$1() {
	  if (this.unsubscribeId !== -1) {
	    this.context[channel].unsubscribe(this.unsubscribeId);
	  }
	}
	
	var withTheme = function withTheme(Component$$1) {
	  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
	
	  function _render() {
	    return React.createElement(Component$$1, _extends({
	      theme: this.state.theme
	    }, this.props));
	  }
	
	  var WithTheme =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inheritsLoose(WithTheme, _React$Component);
	
	    function WithTheme() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = WithTheme.prototype;
	    _proto.componentWillMount = _componentWillMount$1;
	    _proto.componentWillUnmount = _componentWillUnmount$1;
	    _proto.render = _render;
	    return WithTheme;
	  }(React.Component);
	
	  WithTheme.displayName = "WithTheme(" + componentName + ")";
	  WithTheme.contextTypes = contextTypes;
	  return hoistNonReactStatics(WithTheme, Component$$1);
	};
	
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.channel = channel;
	exports.contextTypes = contextTypes;
	exports.createBroadcast = createBroadcast;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createEmotion = _interopDefault(__webpack_require__(48));
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var _createEmotion = createEmotion(context);
	var flush = _createEmotion.flush;
	var hydrate = _createEmotion.hydrate;
	var cx = _createEmotion.cx;
	var merge = _createEmotion.merge;
	var getRegisteredStyles = _createEmotion.getRegisteredStyles;
	var injectGlobal = _createEmotion.injectGlobal;
	var keyframes = _createEmotion.keyframes;
	var css = _createEmotion.css;
	var sheet = _createEmotion.sheet;
	var caches = _createEmotion.caches;
	
	exports.flush = flush;
	exports.hydrate = hydrate;
	exports.cx = cx;
	exports.merge = merge;
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.injectGlobal = injectGlobal;
	exports.keyframes = keyframes;
	exports.css = css;
	exports.sheet = sheet;
	exports.caches = caches;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(5));
	var emotion = __webpack_require__(50);
	var createEmotionStyled = _interopDefault(__webpack_require__(102));
	
	var index = createEmotionStyled(emotion, React);
	
	exports['default'] = index;
	Object.keys(emotion).forEach(function (key) { exports[key] = emotion[key]; });
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(125);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotionTheming = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Canvas = /*#__PURE__*/(0, _reactEmotion2.default)("canvas", {
	  target: 'e1ihof6f0'
	})({
	  width: "100%",
	  height: "100vh"
	});
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Home.prototype.componentDidMount = function componentDidMount() {
	    // TODO figure out why PaperJS crashes during `gatsby build`, remove
	    // global import from cdnjs
	    var _props$theme$grid$bre = this.props.theme.grid.breakpoints,
	        mobile = _props$theme$grid$bre.mobile,
	        tablet = _props$theme$grid$bre.tablet,
	        desktop = _props$theme$grid$bre.desktop,
	        large = _props$theme$grid$bre.large;
	
	    var c = document.getElementById("homeCanvas");
	    var scrollWidth = c.scrollWidth,
	        scrollHeight = c.scrollHeight;
	
	    paper.setup(c);
	
	    var xPoints = void 0;
	    var pxPerSecond = 10;
	    if (scrollWidth <= mobile) {
	      xPoints = 7;
	    } else if (scrollWidth <= tablet) {
	      xPoints = 12;
	    } else if (scrollWidth <= desktop) {
	      xPoints = 16;
	    } else if (scrollWidth <= large) {
	      xPoints = 20;
	    } else {
	      xPoints = 22;
	    }
	    var size = Math.ceil(scrollWidth / xPoints);
	    var yPoints = Math.ceil(scrollHeight / size);
	
	    var groupQueue = [new paper.Group(), new paper.Group()];
	    groupQueue.forEach(function (group, i) {
	      var g = new Grid(xPoints + 1, yPoints + 1, size, size);
	      var areas = g.getShapeAreas();
	      areas.forEach(function (area) {
	        var shape = createRandomShape(area);
	        shape.fillColor = "black";
	        group.addChild(shape);
	      });
	      group.position.y = -i * ((yPoints + 1) * size);
	    });
	    var current = 0;
	    paper.view.translate(new paper.Point(0, (yPoints + 1) * size / 2));
	    paper.view.onFrame = function (event) {
	      var trans = Math.ceil(pxPerSecond * event.delta);
	      current += trans;
	      groupQueue.forEach(function (g) {
	        g.position.y += trans;
	      });
	      if (current >= (yPoints + 1) * size) {
	        var old = groupQueue.shift();
	        old.remove();
	        var newGroup = new paper.Group();
	        var y = groupQueue[0].position.y;
	        var g = new Grid(xPoints + 1, yPoints + 1, size, size);
	        var areas = g.getShapeAreas();
	        areas.forEach(function (area) {
	          var shape = createRandomShape(area);
	          shape.fillColor = "black";
	          newGroup.addChild(shape);
	        });
	        newGroup.position.y = y - (yPoints + 1) * size;
	        groupQueue.push(newGroup);
	        current = 0;
	      }
	    };
	  };
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(Canvas, { id: 'homeCanvas' });
	  };
	
	  return Home;
	}(_react.Component);
	
	exports.default = (0, _emotionTheming.withTheme)(Home);
	
	// TODO ES6-ify helper functions and move them into a separate file.
	
	function MPoint(x, y) {
	  this.x = x;
	  this.y = y;
	  this.occupied = false;
	}
	
	MPoint.prototype.occupy = function () {
	  this.occupied = true;
	};
	
	MPoint.prototype.isOccupied = function () {
	  return this.occupied;
	};
	
	function createShapeArea(matrixX, matrixY, matrixXSize, matrixYSize, matrixXN, matrixYN) {
	  return {
	    x: matrixX * matrixXSize,
	    y: matrixY * matrixYSize,
	    w: matrixXSize * matrixXN,
	    h: matrixYSize * matrixYN
	  };
	}
	
	function Grid(w, h, xSize, ySize) {
	  var ys = [];
	  for (var y = 0; y < h; y++) {
	    var xs = [];
	    for (var x = 0; x < w; x++) {
	      xs.push(new MPoint(x, y));
	    }
	    ys.push(xs);
	  }
	  this.data = ys;
	  this.w = w;
	  this.h = h;
	  this.xSize = xSize;
	  this.ySize = ySize;
	}
	
	Grid.prototype.exists = function (x, y) {
	  return y < this.h && y > -1 && x < this.w && x > -1;
	};
	
	Grid.prototype.getUnoccupiedPoints = function () {
	  return this.data.reduce(function (accum, points) {
	    points.forEach(function (p) {
	      if (!p.isOccupied()) {
	        accum.push(p);
	      }
	    });
	    return accum;
	  }, []);
	};
	
	Grid.prototype.hasOccupiedSpots = function (startX, startY, xN, yN) {
	  for (var y = startY; y < startY + yN; y++) {
	    for (var x = startX; x < startX + xN; x++) {
	      if (!this.exists(x, y)) {
	        return true;
	      }
	      var p = this.data[y][x];
	      if (p.isOccupied()) {
	        return true;
	      }
	    }
	  }
	  return false;
	};
	
	Grid.prototype.fillAndGetShapeArea = function (startX, startY, xN, yN) {
	  // assumes every point exists and is not already occupied
	  for (var y = startY; y < startY + yN; y++) {
	    for (var x = startX; x < startX + xN; x++) {
	      var p = this.data[y][x];
	      p.occupy();
	    }
	  }
	
	  return createShapeArea(startX, startY, this.xSize, this.ySize, xN, yN);
	};
	
	Grid.prototype.fillUpTo = function (x, y, xN, yN) {
	  // TODO support filling max x & y separately
	  var currentY = yN;
	  var currentX = xN;
	  while (this.hasOccupiedSpots(x, y, currentX, currentY)) {
	    currentX--;
	    currentY--;
	  }
	  return this.fillAndGetShapeArea(x, y, currentX, currentY);
	};
	
	Grid.prototype.getShapeAreas = function () {
	  var shapeCanvases = [];
	  var unoccupied = this.getUnoccupiedPoints();
	  while (unoccupied.length) {
	    var p = unoccupied[Math.floor(Math.random() * unoccupied.length)];
	    var n = Math.ceil(1 + Math.random() * 3);
	    var canvas = this.fillUpTo(p.x, p.y, n, n);
	    shapeCanvases.push(canvas);
	    unoccupied = this.getUnoccupiedPoints();
	  }
	  return shapeCanvases;
	};
	
	function createEllipse(area) {
	  return new paper.Shape.Ellipse(new paper.Rectangle(new paper.Point(area.x, area.y), new paper.Size(area.w, area.h)));
	}
	
	function createTriangle1(area) {
	  return new paper.Path({
	    segments: [[area.x, area.y], [area.x, area.y + area.h], [area.x + area.w, area.y + area.h]],
	    closed: true
	  });
	}
	
	function createTriangle2(area) {
	  return new paper.Path({
	    segments: [[area.x, area.y], [area.x + area.w, area.y], [area.x + area.w, area.y + area.h]],
	    closed: true
	  });
	}
	
	function createTriangle3(area) {
	  return new paper.Path({
	    segments: [[area.x + area.w, area.y], [area.x, area.y], [area.x, area.y + area.h]],
	    closed: true
	  });
	}
	
	function createTriangle4(area) {
	  return new paper.Path({
	    segments: [[area.x, area.y + area.h], [area.x + area.w, area.y + area.h], [area.x + area.w, area.y]],
	    closed: true
	  });
	}
	
	function createRectangle(area) {
	  return new paper.Path({
	    segments: [[area.x, area.y], [area.x, area.y + area.h], [area.x + area.w, area.y + area.h], [area.x + area.w, area.y]],
	    closed: true
	  });
	}
	
	var shapeFuncs = [createEllipse, createRectangle, createTriangle1, createTriangle2, createTriangle3, createTriangle4];
	
	function createRandomShape(area) {
	  return shapeFuncs[Math.floor(Math.random() * shapeFuncs.length)](area);
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-27007f0c52994c137164.js